import React from 'react';

class Card extends React.Component {

    render() {
        return (
            <div id="card-container">
                <div id="card-picture">
                    <div id="card-img"/>
                </div>
                <div id="card-text">Supernova is a small, full-stack web development consultancy based in Nashville, Tennessee, USA and
                    run
                    by John-Marvin Davis
                </div>
            </div>
        );
    }
}

export default Card;
